import type { AppProblemModel } from '@/services/api/AppProblemModel'

/**
 * Appends a trailing support-reference suffix to `message` when `problem`
 * carries a `requestId`, for sinks that show that reference to the person
 * reporting an issue. Shared so every call site formats the suffix
 * identically instead of hand-rolling this ternary.
 */
export const appendRequestReference = (message: string, problem: AppProblemModel): string => {
  const reference = problem.requestId === null ? '' : ` Reference: ${problem.requestId}`
  return `${message}${reference}`
}
